export const POSITION_ADDRESS_KEY = 'address';
export const POSITION_ALTITUDE_KEY = 'altitude';
export const POSITION_KEY = 'coordinates';
export const POSITION_DISTANCE_ADD = 'distanceAdd';
export const POSITION_DIST_CUMULATIVE_KEY = 'distanceCumulative';
export const POSITION_ID_KEY = 'id';
export const POSITION_IGNITION_ON_KEY = 'ignitionOn';
export const POSITION_IS_PRIVATE_KEY = 'isPrivate';
export const POSITION_RIDE_ID_KEY = 'rideId';
export const POSITION_SPEED_KEY = 'speed';
export const POSITION_GPS_TS_KEY = 'gpsTs';
export const POSITION_VEHICLE_ID = 'vehicleId';
export const POSITION_WAYPOINTS = 'waypoints';
export const POSITION_EVENTS = 'events';
export const POSITION_ALARMS = 'alarms';

export const POSITION_TABLE_KEY = `v2/ride-book`;
export const POSITION_TABLE_SETTINGS = 'ride_book_position_v2';
export const POSITION_QUERY_KEY = 'positions';

export const TableSettingsKeys = {
  address: 'table_list.columns.positions.address',
  altitude: 'table_list.columns.positions.altitude',
  coordinates: 'table_list.columns.positions.coordinates',
  distanceAdd: 'table_list.columns.positions.distanceAdd',
  ignitionOn: 'table_list.columns.positions.ignitionOn',
  rideId: 'table_list.columns.positions.rideId',
  speed: 'table_list.columns.positions.speed',
  gpsTs: 'table_list.columns.timestamp',
  isPrivate: 'table_list.columns.positions.isPrivate',
  distanceCumulative: 'table_list.columns.positions.distanceCumulative',
  waypoints: 'table_list.columns.positions.waypoints',
  events: 'table_list.columns.positions.events',
  alarms: 'table_list.columns.positions.alarms',
};
